import Vue from './vue-config'
import nformrInsta from './components/nformr-insta'

var vues = document.querySelectorAll('.vue-generic')

vues.forEach(v => {
    new Vue({
        el: v,
        components: {
            nformrInsta
        },
        data: {
            overlay: 0
        },
        methods: {
            closeOverlay(e) {
                this.overlay = 0
            }
        },
        mounted() {
            window.lazyLoad.update()
        }
    })
})
